import React, { useState, useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import clsx from 'clsx';

const days = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function generateCalendar(year, month) {
  const start = new Date(year, month, 1);
  const end = new Date(year, month + 1, 0);
  const daysArray = [];
  const startDay = start.getDay();
  const totalDays = end.getDate();

  for (let i = 0; i < startDay; i++) {
    daysArray.push(null);
  }
  for (let i = 1; i <= totalDays; i++) {
    daysArray.push(i);
  }
  return daysArray;
}

export default function CustomCalendar() {
  const today = new Date();
  const [selectedDate, setSelectedDate] = useState(today);
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());

  const scrollRef = useRef(null);

  const calendarDays = generateCalendar(today.getFullYear(), currentMonth);

  const handleDateClick = (date) => {
    if (date !== null) {
      setSelectedDate(new Date(today.getFullYear(), currentMonth, date));
    }
  };

  useEffect(() => {
    const itemHeight = 32;
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        top: currentMonth * itemHeight,
        behavior: 'smooth'
      });
    }
  }, [currentMonth]);

  const handleScroll = (e) => {
    const itemHeight = 32;
    const index = Math.round(e.target.scrollTop / itemHeight);
    if (index >= 0 && index < months.length) {
      setCurrentMonth(index);
    }
  };

  return (
    <div className="w-[700px] h-[500px] p-6 flex flex-col bg-white shadow rounded-lg">
      {/* Tabs */}
      <div className="flex mb-4 space-x-4">
        {["Tab 1", "Tab 2", "Tab 3", "Tab 4"].map((tab, index) => (
          <button
            key={index}
            className="w-[150px] h-[35px] border rounded text-sm text-black hover:bg-gray-100"
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Calendar and Month Scroll */}
      <div className="flex flex-1">
        {/* Calendar */}
        <div className="w-[500px]">
          <div className="grid grid-cols-7 text-[14px] text-gray-500 mb-2">
            {days.map((d) => (
              <div key={d} className="text-center">
                {d}
              </div>
            ))}
          </div>
          <div className="grid grid-cols-7 gap-y-2 text-[14px]">
            {calendarDays.map((day, i) => {
              const isToday =
                day === today.getDate() && currentMonth === today.getMonth();
              const isSelected =
                day === selectedDate.getDate() &&
                currentMonth === selectedDate.getMonth();
              const isPast =
                new Date(today.getFullYear(), currentMonth, day) < today;
              return (
                <div
                  key={i}
                  onClick={() => handleDateClick(day)}
                  className={clsx(
                    "w-[34px] h-[34px] flex items-center justify-center rounded cursor-pointer",
                    {
                      'bg-[#FFB525] text-white': isToday || isSelected,
                      'text-gray-400': isPast && day !== null,
                      'text-black': !isPast && day !== null,
                      '': day === null
                    }
                  )}
                >
                  {day || ''}
                </div>
              );
            })}
          </div>
        </div>

        {/* Mystery Style Scroller */}
        <div className="w-[100px] ml-6 relative">
          <div className="relative h-[290px] overflow-hidden">
            <div className="absolute top-[129px] left-0 w-full h-[32px] border-t border-b border-black z-10 pointer-events-none bg-white" />
            <div
              ref={scrollRef}
              onScroll={handleScroll}
              className="h-[290px] overflow-y-scroll scrollbar-none flex flex-col items-center snap-y snap-mandatory"
            >
              {months.map((month, i) => (
                <div
                  key={i}
                  className={clsx(
                    "text-[14px] py-[8px] snap-start w-full text-center",
                    {
                      'text-black text-[16px] font-semibold': i === currentMonth,
                      'text-gray-400': i !== currentMonth
                    }
                  )}
                >
                  {month}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
